import TypesChannel from "../../../data/types/TypesChannel";
import TypesDuration from "../../../data/types/TypesDuration";
import DropDown from "/src/components/UI/DropDown/DropDown";
import "./AnalyticsTopBar.css";
import Analytics from "/src/assets/img/svg/analytics-blue.svg";
import Channels from "/src/assets/img/svg/devices.svg";
import Calendar from "/src/assets/img/svg/calendar.svg";
import Phone from "/src/assets/img/svg/telephony.svg";
import Web from "/src/assets/img/svg/web.svg";
import { useAnalyticsStateContext, useAnalyticsDispatchContext } from "../../../context/AnalyticsContext";
import BuildMetricsChoice from "../../../utils/BuildMetricsChoice";
import useAnalyticsTopBarHookData from "./useAnalyticsTopBarHookData";
import AnalyticsTopBarAction from "./AnalyticsTopBarAction";
import { useEffect } from "react";

function AnalyticsTopBar({ name }) {
    const dispatch = useAnalyticsDispatchContext();

    const {
        channel_id,
        firstPeriod,
        channel_type_id,
        periodChoice,
        channels,
        metrics,
        condition_id,
        redirection_id,
        metrics_id,
    } = useAnalyticsStateContext();

    useAnalyticsTopBarHookData(name, channel_type_id, firstPeriod, channel_id, condition_id, redirection_id);

    const { setValueDropdown, setValueDropdownDate, setValueDropdownMetric } = AnalyticsTopBarAction(metrics);

    var channelsChoice = channels.map( channel => { return { value : channel.id, text : channel.channel_name, icon : <i className="flag-icon flag-icon-fr" style={{marginRight : 10}}></i>}})
    channelsChoice = [{value : null, text : 'All'}, ...channelsChoice]
    const metricsChoice = BuildMetricsChoice(metrics)

    const width = 380;

    var metric_id_fix = null; // par defaut on affiche "all metrics"

    /* //pour changer la valeur par defaut des metrics a afficher en arrivant sur la page
    var metric_id_fix = metrics_id;

    if (metrics_id != null && condition_id == metrics_id) {
        metric_id_fix = metric_id_fix + "-condition_id";
    }

    if (metrics_id != null && redirection_id == metrics_id) {
        metric_id_fix = metric_id_fix + "-redirection_id";
    }
    */
    const TypesDurationForDropdown = [...TypesDuration];
    const customChoice =
        periodChoice == "custom"
            ? { value: "custom", text: `${firstPeriod.date_start} - ${firstPeriod.date_end}` }
            : { value: "custom", text: "Custom period" };
    TypesDurationForDropdown.push(customChoice);

    var icon;
    if (channel_type_id == 2 || channel_type_id == 3) {
        icon = Phone;
    }

    if (channel_type_id == 1 || channel_type_id == 4) {
        icon = Web;
    }

    useEffect(() => {
        dispatch({ type: "RESET_VIEW_TO_DATES" });
    }, [metrics_id, dispatch]);

    return (
        <div className="top_elements">
            <div>
                <DropDown
                    name="periodChoice"
                    choices={TypesDurationForDropdown}
                    width="280px"
                    icon={Calendar}
                    defaultChoice={periodChoice}
                    setValue={setValueDropdownDate}
                    hideSelectItem={false}
                />
            </div>
            <div>
                <DropDown
                    name="channel_type_id"
                    choices={TypesChannel}
                    width="220px"
                    icon={Channels}
                    setValue={setValueDropdown}
                />
            </div>
            { channel_type_id != null ? <div>
                <DropDown name="channel_id" className="analytics_top_channels_dropdown" choices={channelsChoice} icon={icon} width="240px" setValue={setValueDropdown}/>
            </div> : null}
            <div style={{ minWidth : width}}>
                <DropDown name="metric_id" choices={metricsChoice} width={width} icon={Analytics} defaultChoice={metric_id_fix} setValue={setValueDropdownMetric}/>

            </div>
        </div>
    );
}

export default AnalyticsTopBar;
